import { combineLatest, filter, Observable, Subject, takeUntil } from 'rxjs';
import { Component, Input, OnChanges, OnInit, Output, output, SimpleChange } from '@angular/core';
import { Tarea, TipoTarea } from '../../../../models/tareas.model';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { UserAvatarWidgetComponent } from 'app/modules/GlobalComponents/user-avatar-component';
import { MatMenuModule } from '@angular/material/menu';
import { PriorityFlagComponent } from "../../../GlobalComponents/priority-flag.component";
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { AddUserAvatarComponent } from "../../../GlobalComponents/add-user-avatar/add-user-avatar.component";
import { SolicitudesService } from '../../solicitudes/solicitudes.service';
import { Usuario } from 'app/models/usuarios.model';
import { DetalleTareaService } from '../detalle-tareas-service';
import { environment } from 'environments/environments';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { StatusStickerComponent } from 'app/modules/GlobalComponents/status sticker.component';
import { UtilsService } from 'app/modules/utils-service';
import { DatosUsuarioAsignado } from 'app/models/usuarios-asignados.model';
import { CompletarGestionComponent } from 'app/modules/SharedEntitiesComponents/modal-completar-gestion/completar-gestion.component';
import { MatDialog } from '@angular/material/dialog';
import { CambiarFechaLimiteComponent } from 'app/modules/GlobalComponents/cambiar-fecha-limite/cambiar-fecha-limite.component';
import { CONSTANTS } from 'app/core/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'task-info',
    templateUrl: 'task-info.component.html',
    imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    FormsModule,
    MatSelectModule,
    //UserAvatarWidgetComponent,
    MatMenuModule,
    PriorityFlagComponent,
    AddUserAvatarComponent,
    StatusStickerComponent,
    UserAvatarWidgetComponent,
    HasPermissionsDirective
]
})

export class TaskInfoComponent implements OnInit {
    task: Tarea; 
    prioridadList: Tipologia[]= []
    prioridadSeleccionada : Tipologia | null
    estadoTareaList: Tipologia[] = []
    estadoTareaList$: Observable<Tipologia[]>
    estadoSeleccionado: Tipologia
    DescripcionTarea: string= ''
    estadoTarea:number
    tipologiaIdAdmitida:number= environment.TIPOLOGIA_ID_ESTADO_ADMITIDA
    tipologiaIdRechazada:number = environment.TIPOLOGIA_ID_ESTADO_RECHAZADA
    usuariosAsignados$: Observable<DatosUsuarioAsignado[]>;
    
    ID_ESTADO_GESTION_COMPLETADA: number= CONSTANTS.ID_ESTADO_GESTION_COMPLETADA

    estadoBloqueado:boolean= false

    private _unsubscribeAll: Subject<any> = new Subject<any>();

     taskDetails$: Observable<Tarea>;

    constructor(
        private solicitudesService: SolicitudesService,
        private _detalleTareasService: DetalleTareaService,
        private _activatedRoute: ActivatedRoute,
        private _router:Router,
        private utilsService:UtilsService,
        public dialog: MatDialog,
    ) {
        this.usuariosAsignados$ = this._detalleTareasService._usuariosAsignados$
        this.estadoTareaList$ = this._detalleTareasService.estadosTarea$
    }



    ngOnInit(): void {
        this.getTipologiaPrioridad()

        combineLatest([
            this._detalleTareasService.detalleTarea$,
            this._detalleTareasService.estadosTarea$
            ])
            .pipe(
            takeUntil(this._unsubscribeAll),
            filter(([task, estados]) => !!task?.estadoTarea && estados.length > 0)
            )
            .subscribe(([task, estados]) => {
            this.task = task;
            this.estadoTareaList = estados;

            this.estadoSeleccionado = this.estadoTareaList.find(
                e => e.tipologiaId === this.task.estadoTarea.tipologiaId
            );

        });
    }

    abrirModalFechaLimite(){
        if(!this.task) return;
        this.dialog.open(CambiarFechaLimiteComponent, {
            panelClass: ['w-full', 'md:w-4/12'],
            maxHeight: 'calc(100vh - 4rem)',
            data: { tarea: this.task }
        });
    }

      
    // Función de comparación para <mat-select>.    
    compareEstados = (estado1: Tipologia | null, estado2: Tipologia | null): boolean => {
        // Si ambos objetos existen, comparar por su propiedad tipologiaId
        if (estado1 && estado2) {
            return estado1.tipologiaId === estado2.tipologiaId;
        }
        // Si alguno es null o undefined, comparar directamente
        return estado1 === estado2;
    };

    actualizarEstado(tareaUuid: string, estadoSeleccionado: Tipologia) {
        const { tipologiaId: estadoTarea } = estadoSeleccionado;
        const params = { estadoTarea };
    
        if (estadoTarea === environment.TIPOLOGIA_ID_ESTADO_ADMITIDA) {
            this.postAprobarSolicitud();
            return;
        }
    
        if (estadoTarea === environment.TIPOLOGIA_ID_ESTADO_SOLICITUD_CORRECCION) {
            this.postEstadoCorreccion();
            return;
        }

        this.utilsService.open_confirm_dialog(`Esta seguro de que desea actualizar el estado de ${this.task.nombreTarea}.`, 'Confirmar cambio de Estado')
            .subscribe(response=>{
                if(response=== 'confirmed'){
                    this._detalleTareasService.putEstadoTarea(tareaUuid, params)
                    .then(() => {
                        return Promise.all([
                            this.actualizarDatosTarea()
                        ]);
                    })
                    .catch(error => console.error("Error actualizando estado de la tarea:", error));
                }else{//si el usuario cierra el modal sin confirmar, regresara a su estado anterior
                    this.estadoSeleccionado = this.estadoTareaList.find(
                        estado => estado.tipologiaId === this.task.estadoTarea.tipologiaId 
                    )}
            })
    }
    

    actualizarPrioridad(tareaUuid:string, prioridadSeleccionada: Tipologia){
        const prioridad =prioridadSeleccionada.tipologiaId
        const params = {prioridad}
        this._detalleTareasService.putPriodidadTarea(tareaUuid, params)
            .then((response)=>{
                this.actualizarDatosTarea()
            })
    }

    actualizarUsurioAsignado(usuario:Usuario, tareaUuid:string){
            this.solicitudesService.putUsuarioAsignado(usuario.usuarioId, tareaUuid)
                .then(() => {
                    this.actualizarDatosTarea()
                    this._detalleTareasService.getUsuariosAsignados(this.task.tareaUuid)
                });
        }
    
    getTipologiaPrioridad(){
        const tipologiaPrioridad= environment.TIPOLOGIA_PADRE_ID_PRIORIDAD
        this._detalleTareasService.getTipologias(tipologiaPrioridad)
            .then((response: TipologiasInterface)=>{
                this.prioridadList= response[0].tipologias
            })
    }

    putDescripcion(){
        const descripcion=this.task.descripcion
        this._detalleTareasService.putDescripcion(descripcion, this.task.tareaUuid)
            .then(response =>{
                this._detalleTareasService.getActividadesByTask(this.task.tareaUuid)
            })
    }

    //servicio para controlar el cambio de estado CORRECCION
    postEstadoCorreccion(){
        this.utilsService.open_confirm_dialog(`Al cambiar a este estado se notificará al solicitante sobre los documentos y bloques de información rechazados esta seguro que desea continuar.`, 'Enviar Datos a Validación')
        .subscribe(response=>{
            if(response == 'confirmed'){
                this._detalleTareasService.postRevisionFormularioVa(this.task.tareaUuid)
                .then((response)=>{
                    this.actualizarDatosTarea()
                })
                .catch(error => {//si ya ha sido rechazada regresara su valor al estado anterior
                    this.estadoSeleccionado = this.estadoTareaList.find(
                        estado => estado.tipologiaId === this.task.estadoTarea.tipologiaId
                    )
                });
            }else{//si el usuario cierra el modal sin confirmar, regresara a su estado anterior
                this.estadoSeleccionado = this.estadoTareaList.find(
                    estado => estado.tipologiaId === this.task.estadoTarea.tipologiaId 
                )
            }
            
        })
        
    }

    //Aprobar Solicitud
    postAprobarSolicitud(){
        this.utilsService.open_confirm_dialog(`Esta seguro que desea Admitir la solicitud  ${this.task.nombreTarea}`, 'Aceptar Solicitud')
        .subscribe(response=>{
            if(response == 'confirmed'){
                this._detalleTareasService.postAprobarSolicitud(this.task.tareaUuid)
                .then((response:any)=>{
                    this._router.navigate(['/task-details/task/', response.data]);
                    
                    //this.actualizarDatosTarea()
                }).catch(error => {//si ya ha sido rechazada regresara su valor al estado anterior
                    this.estadoSeleccionado = this.estadoTareaList.find(
                        estado => estado.tipologiaId === this.task.estadoTarea.tipologiaId
                    )
                });
            }else{//si el usuario cierra el modal sin confirmar, regresara a su estado anterior
                this.estadoSeleccionado = this.estadoTareaList.find(
                    estado => estado.tipologiaId === this.task.estadoTarea.tipologiaId 
                )
            }
        })
    }


    ngOnChanges(changes: SimpleChange) {
        if (changes['task']) {
            this.estadoSeleccionado = this.estadoTareaList.find(
                estado => estado.tipologiaId === this.task.estadoTarea.tipologiaId
            )  
        }
    }

    actualizarDatosTarea(){
        this._detalleTareasService.getActividadesByTask(this.task.tareaUuid)
        this._detalleTareasService.getTaskDetails(this.task.tareaUuid)
    } 

    eliminarUsuarioAsignado(usuario:DatosUsuarioAsignado) {
        this.utilsService.open_confirm_dialog(`Esta seguro que desea eliminar a ${usuario.usuarioAsignado.nombreCompleto} de la tarea ${this.task.nombreTarea}`, 'Eliminar Usuario Asignado')
            .subscribe(response => {
                if (response === 'confirmed') {
                    this._detalleTareasService.deleteUsuarioAsignado(usuario.asignacionId)
                        .then(() => {
                            this.actualizarDatosTarea()
                            this._detalleTareasService.getUsuariosAsignados(this.task.tareaUuid)
                        });
                }
            })
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
